import React from "react";
import Link from "@components/link";
import BredgeCapitalLogo from "../../img/bridge-capital-logo.svg";
import ArrowLogo from "../../img/arrow-logo.svg";
import {
  PreviewStyles, HeaderStyles, BodyStyles,
} from "./FooterPart.styles";
import i18nStrings from "../../strings/stings";

const FooterPart = () => {
  const strings = i18nStrings;

  return (
    <PreviewStyles>
      <HeaderStyles>
        <img alt="" className="header-image" src={BredgeCapitalLogo} />
        <div className="header-phone">
          {strings.phoneInMoscow}<br />
          <Link className="phone" href="tel:88005500992" theme="dark">{strings.phoneNumber}</Link>
        </div>
      </HeaderStyles>
      <BodyStyles>
        <div>
          <div className="footer">
            <Link className="footer-items" href="https://drive.google.com/file/d/1Y-IsYIqmdtfKKUaswBosomUGaFM5Unuw/view" target="_blank"><img alt="" className="img-footer" src={ArrowLogo} />{strings.certificateCB}</Link>
            <Link className="footer-items" href="https://drive.google.com/file/d/1SqoA_KGKsyRQU0fqQ73wfnV28_4OSVy_/view" target="_blank"><img alt="" className="img-footer" src={ArrowLogo} />{strings.extractFrom}</Link>
            <Link className="footer-items" href="https://drive.google.com/file/d/11s7VWecJsWQlTfKGk-mIwRSOswhGDK1E/view" target="_blank"><img alt="" className="img-footer" src={ArrowLogo} />{strings.loanRules}</Link>
          </div>
        </div>
        <div className="footer-text">
          {strings.contentFooter}
          <br />
          <br />
          {strings.adressFooter}
          <br /><br /><br />
          <div className="footer-text-bottom">
            <div>
              {strings.dateOfEntry}
            </div>
            <div>
              <Link
                className="links"
                href="https://drive.google.com/file/d/1fMULxHbK8nMHFuxZew82JcTl4BJafT7P/view"
                mode="underline"
                target="_blank"
                theme="dark"
              >{strings.publicOffer}
              </Link>
            </div>
          </div>
        </div>
      </BodyStyles>
    </PreviewStyles>
  );
};

export default FooterPart;
